module.exports = __webpack_public_path__ + "static/media/YGOimageTemp.bceac266.jpg";